import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useLocation } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { authStateSelector } from '../store/selectors/userSelector'
import { useGetUser } from '../api/auth/useGetUser'
import { setAuthenticated, setUser } from '../store/reducers/userReducer'

const RequireAuth = ({ children }: { children: JSX.Element }): JSX.Element => {
  const location = useLocation()
  const { data: user, isError, isLoading } = useGetUser()
  const dispatch = useDispatch()

  const [isLoadingDispatch, setIsLoadingDispatch] = useState(true)

  const isAuthenticated = useSelector(authStateSelector)

  useEffect(() => {
    if (!isLoading) {
      if (!isError) {
        dispatch(setUser(user))
        dispatch(setAuthenticated(true))
        setTimeout(() => setIsLoadingDispatch(false), 0)
      } else {
        setIsLoadingDispatch(false)
      }
    }
  }, [dispatch, isError, isLoading, user])

  if (!isAuthenticated && !isLoadingDispatch) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return (
      <Navigate
        to={`/auth/login?next=${location.pathname}`}
        state={{ from: location }}
        replace
      />
    )
  }

  if (isLoadingDispatch && !isAuthenticated) return <div>Loading...</div>
  return children
}

export default RequireAuth
